import { Box, styled } from '@mui/material';

export const IndicatorContainer = styled(Box)(() => ({
  position: 'absolute',
  zIndex: 999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
}));
